(function () {
	// Delegated once on document, so re-rendered sections keep working without re-binding.
	if (window.__productsPerRowBound) return;
	window.__productsPerRowBound = true;

	document.addEventListener("click", function (e) {
		const button =
			e.target instanceof Element ? e.target.closest(".per-row__button") : null;
		if (!button) return;

		const perRow = button.dataset.perRow;

		document
			.querySelectorAll(".per-row__button")
			.forEach((el) => el.classList.remove("active"));
		if (perRow === undefined) return;

		document
			.querySelectorAll(`[data-per-row="${CSS.escape(perRow)}"]`)
			.forEach((el) => el.classList.add("active"));
		document
			.querySelectorAll("[data-productis-in-row]")
			.forEach((el) => el.setAttribute("data-productis-in-row", perRow));
	});
})();
